import { render, staticRenderFns } from "./xcoinTerms.vue?vue&type=template&id=15284f29&scoped=true&"
import script from "./xcoinTerms.vue?vue&type=script&lang=js&"
export * from "./xcoinTerms.vue?vue&type=script&lang=js&"
import style0 from "./xcoinTerms.vue?vue&type=style&index=0&id=15284f29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15284f29",
  null
  
)

export default component.exports